/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Request_SubmitInputs */

const en_cancel_request_submit = /** @type {(inputs: Cancel_Request_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit cancellation request`)
};

const ja_cancel_request_submit = /** @type {(inputs: Cancel_Request_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル要求を送信`)
};

const fr_cancel_request_submit = /** @type {(inputs: Cancel_Request_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer la demande d'annulation`)
};

const de_cancel_request_submit = /** @type {(inputs: Cancel_Request_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stornierungsanfrage senden`)
};

/**
* | output |
* | --- |
* | "Submit cancellation request" |
*
* @param {Cancel_Request_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cancel_request_submit = /** @type {((inputs?: Cancel_Request_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Request_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_request_submit(inputs)
	if (locale === "ja") return ja_cancel_request_submit(inputs)
	if (locale === "fr") return fr_cancel_request_submit(inputs)
	return de_cancel_request_submit(inputs)
});